import AbstractInfoTab from '../AbstractInfoTab';
import DrawInput from './DrawInput';
import ElementInput from './ElementInput';

export default class InfoTab extends AbstractInfoTab {
    activeInput;

    createInput() {
        this.input = new ElementInput(this.provider, this.container);
        this.drawInput = new DrawInput(this.provider, this.container);
        this.noMode();
    }

    resizeWindow() {
        this.positionInfoTab();
    }

    drawMode() {
        this.input.hide();
        this.placeholder.hide();
        this.drawInput.show();
    }

    noMode() {
        this.drawInput.hide();
        this.input.hide();
        this.placeholder.show();
    }

    setCurrentElement(element) {
        this.currentElement = element;
        if (this.currentElement) {
            this.input.setElement(this.currentElement);
            this.input.show();
            this.placeholder.hide();
            this.drawInput.hide();
        } else {
            this.input.setElement();
            this.input.hide();
            this.placeholder.show();
            this.drawInput.hide();
        }
    }

    reload(element) {
        if (this.currentElement == element) {
            this.input.setElement(element);
        }
    }

    update() {
        this.selection.length > 1
            ? this.input.showSelection()
            : this.input.showInfo();
    }
}
